<template>
  <div class="stats-grid">
    <div class="stat-card stat-total">
      <div class="stat-icon">
        <i class="fas fa-clipboard-list"></i>
      </div>
      <div class="stat-content">
        <p class="stat-label">Total Requêtes</p>
        <p class="stat-value">{{ formatNumber(stats.total_requests) }}</p>
      </div>
    </div>

    <div class="stat-card stat-success">
      <div class="stat-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="stat-content">
        <p class="stat-label">Succès</p>
        <p class="stat-value">{{ formatNumber(stats.success_count) }}</p>
        <p class="stat-percent">{{ successRate }}%</p>
      </div>
    </div>

    <div class="stat-card stat-error">
      <div class="stat-icon">
        <i class="fas fa-exclamation-circle"></i>
      </div>
      <div class="stat-content">
        <p class="stat-label">Échecs</p>
        <p class="stat-value">{{ formatNumber(stats.failure_count) }}</p>
        <p class="stat-percent">{{ failureRate }}%</p>
      </div>
    </div>

    <div class="stat-card stat-time">
      <div class="stat-icon">
        <i class="fas fa-clock"></i>
      </div>
      <div class="stat-content">
        <p class="stat-label">Temps Moyen</p>
        <p class="stat-value">{{ formatResponseTime(stats.avg_response_time) }} ms</p>
        <p class="stat-detail">
          Min: {{ stats.min_response_time || 0 }}ms | 
          Max: {{ stats.max_response_time || 0 }}ms
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogsStats',
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({
        total_requests: 0,
        success_count: 0,
        failure_count: 0,
        avg_response_time: 0,
        min_response_time: 0,
        max_response_time: 0,
      }),
    },
  },
  computed: {
    successRate() {
      if (this.stats.total_requests === 0) return 0;
      return ((this.stats.success_count / this.stats.total_requests) * 100).toFixed(1);
    },
    failureRate() {
      if (this.stats.total_requests === 0) return 0;
      return ((this.stats.failure_count / this.stats.total_requests) * 100).toFixed(1);
    },
  },
  methods: {
    formatNumber(num) {
      return new Intl.NumberFormat('fr-FR').format(num || 0);
    },
    formatResponseTime(time) {
      const numTime = parseFloat(time);
      if (isNaN(numTime)) return 0;
      return numTime.toFixed(1);
    },
  },
};
</script>

<style scoped>
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.25rem;
  margin-bottom: 1.5rem;
}

.stat-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.stat-total .stat-icon {
  background-color: #dbeafe;
  color: #2563eb;
}

.stat-success .stat-icon {
  background-color: #dcfce7;
  color: #16a34a;
}

.stat-error .stat-icon {
  background-color: #fee2e2;
  color: #dc2626;
}

.stat-time .stat-icon {
  background-color: #fef3c7;
  color: #f59e0b;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
}

.stat-percent {
  font-size: 0.875rem;
  color: #16a34a;
  font-weight: 600;
  margin-top: 0.25rem;
}

.stat-detail {
  font-size: 0.75rem;
  color: #9ca3af;
  margin-top: 0.25rem;
}
</style>

